import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function removeName(v) {
  if (v && v.name) {
    // eslint-disable-next-line
    var name = v.name,
        rest = _objectWithoutProperties(v, _excluded);

    return _objectSpread({}, rest);
  }

  return v;
}

function rollup(f) {
  var values = f.values.map(removeName).map(function (v) {
    return _defineProperty({}, f.field, v);
  });
  return _defineProperty({}, f.type || "any", values);
}

function adaptFilters(filters) {
  if (!filters || filters.length === 0) return {};
  var all = filters.map(rollup);
  return {
    all: all
  };
}

function getSort(sortDirection, sortField, sortList) {
  if (sortList && sortList.length) {
    return sortList.map(function (sortItem) {
      return _defineProperty({}, sortItem.field, sortItem.direction);
    });
  } else if (sortField && sortDirection) {
    return _defineProperty({}, sortField, sortDirection);
  } else {
    return undefined;
  }
}

export function adaptRequest(request) {
  var current = request.current,
      resultsPerPage = request.resultsPerPage,
      searchTerm = request.searchTerm,
      sortDirection = request.sortDirection,
      sortField = request.sortField,
      sortList = request.sortList;
  var sort = getSort(sortDirection, sortField, sortList);
  return _objectSpread(_objectSpread({
    query: searchTerm
  }, sort !== undefined && {
    sort: sort
  }), {}, {
    page: _objectSpread(_objectSpread({}, resultsPerPage !== undefined && {
      size: resultsPerPage
    }), current !== undefined && {
      current: current
    }),
    filters: adaptFilters(request.filters)
  });
}